import {
  Logger
} from "./chunk-MG6YGXXR.mjs";

// src/user/index.ts
var setLoggerUser = (user) => {
  Logger.setUser(user);
};

export {
  setLoggerUser
};
//# sourceMappingURL=chunk-ERWD73HR.mjs.map